import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import { ImageAssetFieldsFragmentDoc } from './imageAssetFields.generated';
import { MagicxPromoCategoryFieldsFragmentDoc } from './magicxPromoCategoryFields.generated';
export type PromotionBaseFieldsFragment = { __typename?: 'magicx_promotions', id: string, status?: string | null, internal_name?: string | null, opt_in?: boolean | null, magicx_slug?: string | null, bonus_type?: string | null, DM_Template_ID?: string | null, DM_Max_Amount?: string | null, tag_ID?: string | null, bonus_ID?: string | null, welcome_offer?: boolean | null, prize_refer?: boolean | null, start_date?: any | null, start_time?: any | null, end_date?: any | null, end_time?: any | null, reg_image_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, reg_image_desktop?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, collection?: { __typename?: 'magicx_promo_collections', id: string, internal_name?: string | null, ordering?: number | null, carousel_type?: string | null, translations?: Array<{ __typename?: 'magicx_promo_collections_translations', display_name?: string | null } | null> | null } | null, thumbnail?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_wide?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_hero?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_hero_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, eligible_games?: Array<{ __typename?: 'magicx_promotions_game', game_id?: { __typename?: 'game', game_id?: string | null, provider?: { __typename?: 'game_provider', mediator_id?: string | null } | null, brand?: { __typename?: 'Brand', value: string } | null, translations?: Array<{ __typename?: 'game_translations', display_name?: string | null, slug?: string | null } | null> | null, game_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, tags?: Array<{ __typename?: 'game_game_tags', game_tags_id?: { __typename?: 'game_tags', translations?: Array<{ __typename?: 'game_tags_translations', name?: string | null } | null> | null } | null } | null> | null } | null } | null> | null };

export type CollectionsPromotionBaseFieldsFragment = { __typename?: 'magicx_promotions', id: string, status?: string | null, internal_name?: string | null, opt_in?: boolean | null, magicx_slug?: string | null, bonus_type?: string | null, DM_Template_ID?: string | null, DM_Max_Amount?: string | null, tag_ID?: string | null, bonus_ID?: string | null, welcome_offer?: boolean | null, prize_refer?: boolean | null, start_date?: any | null, start_time?: any | null, end_date?: any | null, end_time?: any | null, reg_image_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, reg_image_desktop?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_wide?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_hero?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_hero_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null };

export const PromotionBaseFieldsFragmentDoc = gql`
    fragment PromotionBaseFields on magicx_promotions {
  id
  status
  internal_name
  opt_in
  magicx_slug
  bonus_type
  DM_Template_ID
  DM_Max_Amount
  tag_ID
  bonus_ID
  welcome_offer
  prize_refer
  reg_image_mobile {
    ...ImageAssetFields
  }
  reg_image_desktop {
    ...ImageAssetFields
  }
  start_date: start_at_date
  start_time: start_at_time
  end_date: end_at_date
  end_time: end_at_time
  collection(filter: {status: {_in: $collectionStatuses}}) {
    ...MagicxPromoCategoryFields
  }
  thumbnail {
    ...ImageAssetFields
  }
  thumbnail_wide {
    ...ImageAssetFields
  }
  thumbnail_hero {
    ...ImageAssetFields
  }
  thumbnail_tall {
    ...ImageAssetFields
  }
  thumbnail_box {
    ...ImageAssetFields
  }
  thumbnail_hero_mobile {
    ...ImageAssetFields
  }
  eligible_games(
    filter: {game_id: {status: {_eq: "published"}, provider: {status: {_eq: "published"}}}}
  ) {
    game_id(filter: null) {
      game_id
      provider(filter: null) {
        mediator_id
      }
      brand {
        value
      }
      translations(
        filter: {languages_language_code: {language_code: {_eq: $language}}}
      ) {
        display_name
        slug
      }
      game_image(filter: null) {
        filename_disk
        width
        height
      }
      tags {
        game_tags_id(filter: null) {
          translations(
            filter: {languages_language_code: {language_code: {_eq: $language}}}
          ) {
            name
          }
        }
      }
    }
  }
}
    ${ImageAssetFieldsFragmentDoc}
${MagicxPromoCategoryFieldsFragmentDoc}`;
export const CollectionsPromotionBaseFieldsFragmentDoc = gql`
    fragment CollectionsPromotionBaseFields on magicx_promotions {
  id
  status
  internal_name
  opt_in
  magicx_slug
  bonus_type
  DM_Template_ID
  DM_Max_Amount
  tag_ID
  bonus_ID
  welcome_offer
  prize_refer
  reg_image_mobile {
    ...ImageAssetFields
  }
  reg_image_desktop {
    ...ImageAssetFields
  }
  start_date: start_at_date
  start_time: start_at_time
  end_date: end_at_date
  end_time: end_at_time
  thumbnail {
    ...ImageAssetFields
  }
  thumbnail_wide {
    ...ImageAssetFields
  }
  thumbnail_hero {
    ...ImageAssetFields
  }
  thumbnail_tall {
    ...ImageAssetFields
  }
  thumbnail_box {
    ...ImageAssetFields
  }
  thumbnail_hero_mobile {
    ...ImageAssetFields
  }
}
    ${ImageAssetFieldsFragmentDoc}`;